import "./TermsConditions.module.css";
import Header from "@/reusable_sections/Header";
import Terms from "./sections/Terms";
import Footer from "@/reusable_sections/Footer";
export default function TermsConditionsPage() {
  return <div>
      <Header />
      <Terms />
      <Footer />
    </div>;
}